import 'babel-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import axios from 'axios'
import router from './router.js'
import App from './App.vue'
import moment from "moment"
import './validator'
import common from "./common.js";
import pageControl from './components/PageControl.vue';
import momentTimezone from "moment-timezone";
import Resource from 'vue-resource'
import UniqueId from 'vue-unique-id';


Vue.use(Resource);
Vue.use(UniqueId);
Vue.use(Vuex);

Vue.use(VueRouter, moment)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$baseUrl = "";
Vue.mixin(common);

Vue.config.productionTip = false
Vue.http.options.root = '/api';

let dialog;
let needLoadingRequestCount = 0
const sessionStore = window.sessionStorage;

Date.prototype.dateDiff = function(interval,objDate){
	var dtEnd = new Date(objDate);
	if(isNaN(dtEnd)) return undefined;
		switch (interval) {
			case "s":return parseInt((dtEnd - this) / 1000);
			case "n":return parseInt((dtEnd - this) / 60000);
			case "h":return parseInt((dtEnd - this) / 3600000);
			case "d":return parseInt((dtEnd - this) / 86400000);
			case "w":return parseInt((dtEnd - this) / (86400000 * 7));
			case "m":return (dtEnd.getMonth()+1)+((dtEnd.getFullYear()-this.getFullYear())*12) - (this.getMonth()+1);
			case "y":return dtEnd.getFullYear() - this.getFullYear();
	}
}

momentTimezone.tz.setDefault('Asia/Taipei')

function startLoading() {
	dialog = bootbox.dialog({
		message: '<p class="text-center mb-0"><i class="fa fa-spin fa-cog"></i> 正在等待回應,請稍候...</p>',
		closeButton: false,
	});
}

function endLoading() {
	dialog.modal('hide')
}

export function showFullScreenLoading() {
	if (needLoadingRequestCount === 0) {
		startLoading()
	}
	needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
	if (needLoadingRequestCount <= 0) return
	needLoadingRequestCount--
	if (needLoadingRequestCount === 0) {
		endLoading();
	}
}

axios.interceptors.request.use(
	config => {
		config.headers["Content-Type"] = "application/json";
		if (sessionStore.getItem("oitToken") !== null) {
			config.headers.Authorization = "Bearer " + sessionStore.getItem("oitToken")
		}
		showFullScreenLoading()
		return config;
	}
)
axios.interceptors.response.use(response => {
		tryHideFullScreenLoading();
		if(response.data.data != null){
			if("token" in response.data.data){
				sessionStore.setItem("oitToken", response.data.data.token);
			}
		}
		return response;
	}, error => {
		if (error.response) {
			tryHideFullScreenLoading();
			if ([401, 403].includes(error.response.status)) {
				bootbox.alert("請求出錯,請重新登入", function(){
					sessionStore.clear();
					window.location.href = "/";
				});
			}else{
				bootbox.alert("請求出錯,請稍後再試");
			}
		}
		return Promise.reject(error);
	}
);

Vue.filter("twoDigits", function (val) {
	if (!val) return "";
	if (parseInt(val) > 9) return val;
	else return "0" + val;
})
Vue.filter("numberWithCommas", function (val) {
	if (!val) return "";
	return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
})

Vue.http.interceptors.push((request, next) => {
	showFullScreenLoading();
	if (sessionStorage.getItem("oitToken")) {
	  request.headers.set('Authorization', "Bearer " + sessionStorage.getItem("oitToken"))
	}
	next((response) => {
		tryHideFullScreenLoading();
		if (response.status === 401) {
			bootbox.alert("請求出錯,請重新登入", function(){
				sessionStore.clear();
				window.location.href = "/";
			});
			
		} else if ([400, 404, 403, 500].includes(response.status)) {
			bootbox.alert("處理您的要求時發生錯誤,請稍後再試")
		}
	});
  });

Vue.component("pageControl", pageControl);

new Vue({
	router,
	render: h => h(App),
	data() {
		return {
			militaryBaseSearch: {
				educateSystem: "",
				dept: "",
				drade: "",
				studentId: "",
				cityId: "",
				areaId: "",
				studentName: "",
				idno: "",
				entryYM: "",
				state: "",
				restOrOutType: "",
				restOrOutDate: null,
				status: "",
				applyItem: "",
				applyStatus: "",
				adminCheck: ""
			}
		}
	},
}).$mount('#app');
